import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLoading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(PulseLoader, {
      loading: true,
      color: "#3F46D6"
    })
  ]))
}
}

})